import React from "react";
import "../App.css";

const VideoLed = () => {
  return (
    <section className="hero-video">
      {/* Video de fondo */}
      <video
        className="hero-video__bg"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src="/13.mp4" type="video/mp4" />
        Tu navegador no soporta videos.
      </video>

      {/* Overlay oscuro */}
      <div className="hero-video__overlay"></div>

    </section>
  );
};

export default VideoLed;